import { SHOW_MAIN_HEADER, SHOW_FOOTER, SHOW_MENU, RESET_STATE } from '../actions/util-actions';

const initialState = {
  showMainHeader: true,
  showMenu: true,
  showFooter: true,
};

export default function utilReducer(state = initialState, action) {
  const { value } = action;
  switch (action.type) {
    case SHOW_MAIN_HEADER:
      return { ...state, showMainHeader: value };
    case SHOW_MENU:
      return { ...state, showMenu: value };
    case SHOW_FOOTER:
      return { ...state, showFooter: value };
    case RESET_STATE:
      return initialState
    default:
      return state;
  }
}
